<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col class="my-3" cols="auto">
          <b-form-group>
            <b-form-radio-group
              v-model="rule.majorityType"
              :options="majorityTypeOptions"
              stacked
            />
          </b-form-group>
        </b-col>
        <b-col class="my-3" cols="auto">
          <b-form-group>
            <b-form-radio-group
              v-model="rule.forOrAgainst"
              :options="forOrAgainstOptions"
              stacked
            />
          </b-form-group>
        </b-col>
        <b-col class="d-inline-flex text-center my-3" cols="auto">
          <div>
            <label class="m-0">{{ $t("catalogs.qui_doit_être") }}</label>
            <b-form-select
              v-model="rule.operators"
              class="w-auto d-block mx-auto"
              :options="operatorsOptions"
            />
          </div>
          <div>
            <label class="m-0">à</label>
            <!-- NOTE: select editable -->
            <div class="select-percent-editable">
              <b-form-select v-model="rule.percent" :options="percentOptions" />
              <b-input v-model="rule.percent" type="number" name="format" />
              <span>%</span>
            </div>
          </div>
        </b-col>
        <b-col class="my-3 text-center" cols="12" sm="6" md="5" lg="4">
          <label class="m-0">
            {{ $t("catalogs.des_tantièmes_ou_des_votants") }} <br />
            {{ $t("catalogs.selon_le_1er_choix") }}
          </label>
          <b-form-select v-model="rule.denominator" class="d-block" :options="denominatorOptions" />
        </b-col>
      </b-row>
      <b-row v-if="rule.majorityType == '2'" class="mt-4">
        <b-col>
          <b-form-group>
            <b-form-radio v-model="rule.cumulMandates" value="1">
              {{ $t("catalogs.avec_cumul_des_mandats") }}
            </b-form-radio>
            <p>
              <font-awesome-icon icon="info-circle" />
              {{ $t("catalogs.Ainsi_1_votant_avec_2_mandats_compte_pour_3_votants") }}
            </p>
            <b-form-radio v-model="rule.cumulMandates" disabled value="2">
              {{ $t("catalogs.sans_cumul_des_mandats") }}
            </b-form-radio>
            <p>
              <font-awesome-icon icon="info-circle" />
              {{ $t("catalogs.Ainsi_1_votant_avec_2_mandats_compte_pour_1_votant") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
    <!-- delete rule -->
    <b-col cols="auto">
      <b-button
        v-if="isRevote"
        class="button btn-blue"
        :class="{ invisible: index == 0 }"
        :disabled="index == 0"
        @click="deleteRevoteRule"
      >
        <font-awesome-icon icon="trash-alt" />
      </b-button>
      <b-button
        v-else
        class="button btn-blue"
        :class="{ invisible: index == 0 }"
        :disabled="index == 0"
        @click="deleteRule"
      >
        <font-awesome-icon icon="trash-alt" />
      </b-button>
    </b-col>
    <div class="majority-rule-border-bottom"></div>
    <!-- add rule -->
    <b-col v-if="index == 0" cols="12">
      <b-row class="my-3 d-flex align-items-center">
        <b-col
          v-if="!isRevote && majority.majority_conditions.rules.length > 1"
          cols="4"
          sm="3"
          md="2"
        >
          <b-form-select
            v-model="majority.majority_conditions.rulesOperator"
            :options="rulesOperatorsOptions"
          />
        </b-col>
        <b-col
          v-if="isRevote && majority.majority_conditions.revoteRules.length > 1"
          cols="4"
          sm="3"
          md="2"
        >
          <b-form-select
            v-model="majority.majority_conditions.revoteRulesOperator"
            :options="rulesOperatorsOptions"
          />
        </b-col>
        <b-button
          v-if="isRevote && majority.majority_conditions.revoteRules.length < 2"
          class="button btn-blue"
          @click="addRevoteRule"
        >
          <font-awesome-icon icon="plus" />
        </b-button>
        <b-button
          v-if="!isRevote && majority.majority_conditions.rules.length < 2"
          class="button btn-blue"
          @click="addRule"
        >
          <font-awesome-icon icon="plus" />
        </b-button>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  majorityTypeOptions,
  forOrAgainstOptions,
  operatorsOptions,
  percentOptions,
  denominatorOptions,
  rulesOperatorsOptions,
} from "@/constants/majority.js";

export default {
  props: {
    majority: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rule: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: null,
    },
    isRevote: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      majorityTypeOptions,
      forOrAgainstOptions,
      operatorsOptions,
      percentOptions,
      denominatorOptions,
      rulesOperatorsOptions,
    };
  },
  methods: {
    deleteRule() {
      this.$emit("deleteRule");
    },
    addRule() {
      this.$emit("addRule");
    },
    deleteRevoteRule() {
      this.$emit("deleteRevoteRule");
    },
    addRevoteRule() {
      this.$emit("addRevoteRule");
    },
  },
};
</script>
